import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as $ from 'jquery';
import DataTable from 'datatables.net';
import moment from 'moment';

import { PageActions, ImageBox, Section, TextArea, TextInput, SwitchInput, ImageInput, EditorInput, DataTabel } from '../components';
import { userActions, generalActions } from '../actions';
import { generalService } from '../services';
import { generalConstants } from '../constants';

class ProjectsPage extends React.Component {
  constructor(props) {
      super(props);

      this.pid = 400 ;
      this.props.dispatch(generalActions.getContent(0,this.pid)); 

      this.state = {
        datatables:[],
        isLoaded :false
      }

  }

  componentWillReceiveProps(props){

    const { content, upload } = props;
    const { data, id } = content;
    const { payload } = this.state;

    if(data){
        console.log("client:", data);
        this.setState({datatables:data});
    }else{
      setTimeout(()=>this.setState({ isLoaded: true}),1000);
    }
  }

  render() {
    const tableElement = $('#table_client');
    (tableElement && tableElement.DataTable());
    
    return (
      <div className={this.state.isLoaded ? "content-wrapper" : "content-wrapper loader-light"}>
      {
        this.state.isLoaded ?
        <form role="form" name="client" className="needs-validation" noValidate="true">
          <section className="content-header clearfix">
            <h1 className="content-header-title">
              Projects
            </h1>
            <div className="btn-placeholder">
              <Link to={generalConstants.URL+"project"}>
                <button type="submit" className="btn btn-primary">
                  <span className="visible-xs"><i className="fa fa-plus"></i>&nbsp;</span>
                  <span className="hidden-xs">Add new project</span>
                </button>
              </Link>
            </div>
          </section>
            <section className="content">
              <table id="table_client" className="display" style={{width: '100%'}}>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Project Name</th>
                    <th>Location</th>
                    <th>Category</th>
                    <th>Year</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.datatables.map((item, index)=>{
                      return(
                        <tr key={index}>
                           <td>{index+1}</td>
                           <td>{item.title}</td>
                           <td>{item.location}</td>
                           <td>{item.category}</td>
                           <td>{item.year}</td>
                           <td><Link to={generalConstants.URL+"project/"+item.id}><i className="fa fa-pencil" title="Edit"></i></Link></td>
                        </tr>
                      )
                    }
                    
                    )
                  }
                </tbody>
              </table>
            </section>
          </form>
          :
        <div className="loader"></div>
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { authentication, general } = state;
    const { content, upload } = general;
    return {
        content,
        upload
    };
}

const connectedProjectsPage = connect(mapStateToProps)(ProjectsPage);
export { connectedProjectsPage as ProjectsPage };


// WEBPACK FOOTER //
// ./src/pages/ProjectsPage.js